import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../context/store';
import { FiHome, FiLogOut, FiActivity, FiUsers, FiBook, FiSettings, FiBarChart2, FiFileText, FiTag } from 'react-icons/fi';
import { getBrand } from '../utils/brand';

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: FiBarChart2 },
  { path: '/admin/activity-log', label: 'Activity Log', icon: FiActivity },
  { path: '/admin/bookings', label: 'Bookings', icon: FiBook },
  { path: '/admin/declarations', label: 'Declarations', icon: FiFileText },
  { path: '/admin/coupons', label: 'Coupons', icon: FiTag },
  { path: '/admin/agents', label: 'Agents', icon: FiUsers },
  { path: '/admin/settings', label: 'Settings', icon: FiSettings },
];

export default function AdminLayout() {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const brand = getBrand(user?.brand);

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <aside className="w-64 bg-primary-900 text-white min-h-screen fixed">
        <div className="p-4 border-b border-primary-700">
          <h1 className="text-lg font-bold">{brand.icon} {brand.name}</h1>
          <p className="text-xs text-primary-300 mt-1">Admin Panel</p>
        </div>
        <nav className="mt-4">
          {navItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path}
                className={`flex items-center px-4 py-3 text-sm transition ${isActive ? 'bg-primary-600 border-r-4 border-brand-orange text-white' : 'hover:bg-primary-700'}`}>
                <Icon className="mr-3" /> {item.label}
              </Link>
            );
          })}
          <hr className="border-primary-700 my-4" />
          <Link to="/" className="flex items-center px-4 py-3 text-sm hover:bg-primary-800">
            <FiHome className="mr-3" /> Agent View
          </Link>
          <button onClick={() => { logout(); window.location.href = '/login'; }}
            className="flex items-center px-4 py-3 text-sm hover:bg-red-800 w-full text-left">
            <FiLogOut className="mr-3" /> Logout
          </button>
        </nav>
        <div className="absolute bottom-4 left-4 right-4">
          <p className="text-xs text-primary-400">Logged in as</p>
          <p className="text-sm font-medium">{user?.name}</p>
        </div>
      </aside>

      {/* Main */}
      <main className="ml-64 flex-1 p-6">
        <Outlet />
      </main>
    </div>
  );
}
